var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRulesOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482 457V457.001V477.5C482 480.053 481.171 481.847 480.487 482.716C480.391 482.838 480.309 482.931 480.243 483H287.757C287.691 482.931 287.609 482.838 287.513 482.716C286.829 481.847 286 480.053 286 477.5V457.001C286 439.103 296.881 431 303.286 431H464.715C471.12 431 482.001 439.103 482 457ZM480.034 483.182C480.034 483.181 480.048 483.17 480.076 483.155C480.049 483.176 480.034 483.184 480.034 483.182ZM287.966 483.182C287.965 483.184 287.951 483.176 287.924 483.155C287.952 483.17 287.966 483.181 287.966 483.182Z",
    stroke: "white",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6934 472.853C-1.73808 449.422 -1.73808 411.432 21.6934 388.001L188.571 221.123C196.381 213.313 209.044 213.313 216.855 221.123L273.423 277.692C281.234 285.502 281.234 298.166 273.423 305.976L106.546 472.853C83.1147 496.285 45.1248 496.285 21.6934 472.853V472.853Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.6934 472.853C-1.73808 449.422 -1.73808 411.432 21.6934 388.001L188.571 221.123C196.381 213.313 209.044 213.313 216.855 221.123L273.423 277.692C281.234 285.502 281.234 298.166 273.423 305.976L106.546 472.853C83.1147 496.285 45.1248 496.285 21.6934 472.853V472.853Z",
    stroke: "white",
    strokeWidth: 80,
    mask: "url(#path-2-inside-1_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.508 172.836L322.177 292.504C324.474 288.104 327.47 283.975 331.165 280.279L346.014 265.43L229.583 148.999L214.734 163.848C211.038 167.543 206.908 170.539 202.508 172.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.666 100.915L394.097 217.347L408.947 202.497C412.642 198.802 416.772 195.806 421.172 193.509L301.503 73.8408C299.207 78.2408 296.211 82.3706 292.515 86.066L277.666 100.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.952,
    y: 128.492,
    width: 170,
    height: 60,
    rx: 30,
    transform: "rotate(-45 136.952 128.492)",
    stroke: "white",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.094,
    y: 315.635,
    width: 170,
    height: 60,
    rx: 30,
    transform: "rotate(-45 324.094 315.635)",
    stroke: "white",
    strokeWidth: 40
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRulesOutline);
export default __webpack_public_path__ + "static/media/ico_rules_outline.5724d2ebc59eb16b1efc535b237e4600.svg";
export { ForwardRef as ReactComponent };